import { useApp } from '@/context/AppContext';
import type { CreateType } from '@/context/AppContext';
import Dropdown from '@/components/base/Dropdown';

const items: { type: CreateType; label: string; icon: string }[] = [
  { type: 'customer', label: 'Yeni Müşteri', icon: 'ri-team-line' },
  { type: 'quote', label: 'Yeni Teklif', icon: 'ri-file-list-3-line' },
  { type: 'project', label: 'Yeni Proje', icon: 'ri-briefcase-line' },
  { type: 'task', label: 'Yeni Görev', icon: 'ri-task-line' },
  { type: 'collection', label: 'Yeni Tahsilat', icon: 'ri-bank-card-line' },
  { type: 'payment', label: 'Yeni Ödeme', icon: 'ri-money-dollar-circle-line' },
  { type: 'purchase', label: 'Yeni Satın Alma', icon: 'ri-shopping-cart-2-line' },
  { type: 'service', label: 'Yeni Servis Kaydı', icon: 'ri-tools-line' },
];

export default function QuickCreateMenu() {
  const { openCreate } = useApp();

  return (
    <Dropdown
      triggerClassName="h-9 gap-1 rounded-md bg-accent-500 px-3 text-sm font-semibold text-white transition-colors hover:bg-accent-600"
      trigger={
        <>
          <i className="ri-add-line text-lg" />
          <span className="hidden whitespace-nowrap sm:inline">Yeni</span>
        </>
      }
    >
      {(close) => (
        <div className="py-1">
          <p className="px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-foreground-400">
            Hızlı Oluştur
          </p>
          {items.map((item) => (
            <button
              key={item.type}
              type="button"
              onClick={() => {
                openCreate(item.type);
                close();
              }}
              className="flex w-full cursor-pointer items-center gap-2.5 rounded-md px-3 py-2 text-left text-sm text-foreground-700 transition-colors hover:bg-background-100"
            >
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-background-100 text-foreground-500">
                <i className={item.icon} />
              </span>
              <span className="whitespace-nowrap">{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </Dropdown>
  );
}